<template>
  <div>
    <el-upload
        action="none"
        ref="upload"
        :multiple="multiple"
        :accept="accept"
        :file-list="postData"
        :on-preview="onPreview"
        :on-remove="onRemove"
        :on-success="onSuccess"
        :on-error="onError"
        :on-progress="onProgress"
        :on-change="onChange"
        :on-exceed="onExceed"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
        :limit="limit"
        :disabled="disabled"
    >
      <!--    <div>上传图片</div>-->
<!--      <i class="el-icon-plus"></i>-->
      <el-button size="small" type="primary"  v-if="postData.length < limit ? true : false">点击上传</el-button>
    </el-upload>
<!--    <el-dialog :visible.sync="dialogVisible">-->
<!--      <audio width="100%" :src="dialogImageUrl" alt="" />-->
<!--    </el-dialog>-->
  </div>
</template>
<script>
import OSS from 'ali-oss';
var client = {};
export default {
  name: 'FileUploader',
  data(){
    return {
      postData: [],
      dialogImageUrl: '',
      dialogVisible: false,
      ossAccessTokenURL: 'https://api.ccachina.net/core/attachment/aliOssSts',
      ossFileURL: 'https://ccago.oss-cn-hangzhou.aliyuncs.com',
    }
  },
  props: {
    fileList: {
      type: Array,
      required: true,
    },
    accept: {
      type: String,
      default: 'image/*'
    },
    multiple: {
      type: Boolean,
      required: false,
    },
    limit: {
      type: Number,
      default: 0,
    },
    drag: Boolean,
    disabled: Boolean,
    onError: Function,
    onProgress: Function,
    onChange: Function,
  },
  computed: {
  },
  mounted() {
    this.postData = this.fileList
  },
  watch: {
    fileList(value) {
      this.postData = value
    }
  },
  methods: {
    onRemove: function (file, fileList) {
      const that = this;
      this.fileList.forEach(function (element, index) {
        if (element.uid == file.uid) {
          that.fileList.splice(index, 1);
        }
      }, this);
    },

    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    onSuccess() {
    },

    onExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.limit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },

    beforeUpload(file) {
      // 文件大小限制
      // const isLt5M = file.size / 1024 / 1024 < 16;
      // if (!isLt5M) {
      //   this.$message.error('不得超过16M');
      //   return false;
      // }
    },

    uploadFile(evt){
      var that = this;
      console.log(that.ossFileURL);

      evt.onProgress({percent: 0});
      OSS.urllib.request(this.ossAccessTokenURL, {method: 'GET'}, function (err, response) {
        let result;
        if (err) {
          that.$message('上传异常:' + err);
          console && console.error(err);
          evt.onError(100);
          return;
        }
        try {
          result = JSON.parse(response);
        } catch (e) {
          return alert('parse sts response info error: ' + e.message);
        }

        client = new OSS({
          accessKeyId: result.data.AccessKeyId,
          accessKeySecret: result.data.AccessKeySecret,
          stsToken: result.data.SecurityToken,
          endpoint: result.data.endpoint,
          bucket: result.data.bucket,
          secure: true
        });
        var suffix = evt.file.name.toLowerCase().split('.').splice(-1)[0];
        console.log(that.ossFileURL);
        var myDate = new Date().getTime();
        let time = myDate + '' + (Math.floor(Math.random() * 1000 + 1));
        let date = that.dateFormat(myDate);
        var file_save_name = 'pc/' + date + '/' + time + '.' + suffix;
        console.log(file_save_name);

        client.multipartUpload(file_save_name, evt.file,{
          progress:function(p,checkpoint){
            console.log('----上传进度----')
            let progress = parseInt(p*100);
            evt.onProgress({percent: progress});
          },

        }).then(function (result) {
          evt.onSuccess();
          console.log(that.ossFileURL);
          var file = {
            url: that.ossFileURL + '/' + file_save_name,
            name: evt.file.name,
            save_name: file_save_name,
          }
          that.postData.push(file);

        }).catch(function (err) {
          console.log(err)
          that.$message({
            message: evt.file.name + '上传失败',
            type: 'warning',
          });
        });
      });
    }
  }
}
</script>



// WEBPACK FOOTER //
// FileUploader.vue?12f1ac26